import { render } from "./ProductArgument.vue?vue&type=template&id=375f4f69"
import script from "./ProductArgument.vue?vue&type=script&lang=js"
export * from "./ProductArgument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__